<div class="relative">
  <header class="absolute top-0 inset-x-0 z-30">
    <ts-nav></ts-nav>
  </header>
  <div class="bg-gray-100">
    <router-outlet></router-outlet>
  </div>
  <ts-footer></ts-footer>
</div>
